import { render, staticRenderFns } from "./ReceiveEdit_Items_List.vue?vue&type=template&id=74dabd96&"
import script from "./ReceiveEdit_Items_List.vue?vue&type=script&lang=js&"
export * from "./ReceiveEdit_Items_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports